import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Register from "./Register";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import VerifyEmail from "./VerifyEmail";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "./components/Dashboard/Dashboard";
import UserList from "./UserList";
import BrokerRedirectHandler from "./components/Dashboard/BrokerRedirectHandler";
import TradesOrders from "./components/Dashboard/TradesOrders";
import { WebSocketProvider } from "./context/WebSocketContext";

function App() {
    return (
        <WebSocketProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
                <Route path="/broker/redirect" element={<BrokerRedirectHandler />} />
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/users"
                    element={
                        <PrivateRoute requiredRole="admin">
                            <UserList />
                        </PrivateRoute>
                    }
                />

                <Route
                    path="/trades-orders"
                    element={
                        <PrivateRoute>
                            <TradesOrders />
                        </PrivateRoute>
                    }
                />

                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="*" element={<Login />} />
            </Routes>
        </BrowserRouter>
        </WebSocketProvider>
    );
}

export default App;
